import React from 'react';

import { QueryResult } from '@apollo/client';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { formUtil } from 'modules';
import {
  FieldPath,
  useForm,
  UseFormSetValue
} from 'react-hook-form';
import * as yup from 'yup';
import {
  ObjectShape, RequiredObjectSchema, TypeOfShape
} from 'yup/lib/object';
import { AnyObject } from 'yup/lib/types';



export function setFieldsFromQuery<TFormState extends Record<string, any>, TFieldValues extends TFormState>(
  formState: TFormState,
  fnSetValue: UseFormSetValue<TFieldValues>,
  fieldPaths: FieldPath<TFieldValues>[]
) {
  _.forEach(fieldPaths, path => {
    fnSetValue(path, _.get(formState, path), { shouldDirty: false });
  });
}



interface IFormFieldsQueryTuple<TFormState extends Record<string, any>> {
  called: boolean;
  loading: boolean;
  data: {
    formState: TFormState;
  };
}

export function useSetFormFields<TFormState extends Record<string, any>, TFieldValues extends TFormState>(
  queryTuple: IFormFieldsQueryTuple<TFormState>,
  fnSetValue: UseFormSetValue<TFieldValues>,
  fieldPaths: FieldPath<TFieldValues>[]
) {
  const [isFormLoaded, setIsFormLoaded] = React.useState(false);

  React.useEffect(
    () => {
      if (queryTuple.called && !queryTuple.loading && !isFormLoaded) {
        setIsFormLoaded(true);
        setFieldsFromQuery(queryTuple.data.formState, fnSetValue, fieldPaths);
      }
    },
    [
      isFormLoaded,
      queryTuple.called,
      queryTuple.loading,
      queryTuple.data.formState,
      fnSetValue,
      fieldPaths
    ]
  );
}



type InferredReturnType<TFormShape extends ObjectShape> = yup.InferType<RequiredObjectSchema<TFormShape, AnyObject, TypeOfShape<TFormShape>>>;

export function useRemoteData2FormState_experimental<TFormShape extends ObjectShape, TContext extends AnyObject, TIn extends TypeOfShape<TFormShape>, TGqlData>({
  tuple,
  schema,
  fnGqlData2FormState
}: {
  tuple: QueryResult<TGqlData>;
  schema: RequiredObjectSchema<TFormShape, TContext, TIn>;
  fnGqlData2FormState: (gqlData?: TGqlData) => InferredReturnType<TFormShape>;
}) {
  const form = useForm<InferredReturnType<TFormShape>>({
    resolver: yupResolver(schema)
  });

  const formState = React.useMemo(() => {
    return fnGqlData2FormState(tuple.data);
  }, [tuple, fnGqlData2FormState]);

  formUtil.useSetFormFields({
    ...tuple,
    data: { formState }
  },

  form.setValue,
  _.keys(formState) as FieldPath<InferredReturnType<TFormShape>>[]);

  return form;
}
